import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

function mapStateToProps(state) {
    const {
        routing: { locationBeforeTransitions: { pathname } },
    } = state;

    return { pathname };
}

const mapDispatchToProps = {};

class Bors extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
    };

    render() {
        return this.props.children;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Bors);



/** WEBPACK FOOTER **
 ** /src/shared/screens/bors/index.js
 **/